import React from 'react';
import {Box} from '@mui/material';
import {t} from '../../themes/statamicTokens';

const palette = {
    success: { bg: t.color.status.successTint, fg: '#047857' },
    warning: { bg: t.color.status.warningTint, fg: '#B45309' },
    danger:  { bg: t.color.status.dangerTint,  fg: '#B91C1C' },
    info:    { bg: t.color.status.infoTint,    fg: '#1D4ED8' },
    neutral: { bg: t.color.status.neutralTint, fg: '#374151' },
};

const StatusPill = ({variant = 'neutral', children, sx}) => {
    const { bg, fg } = palette[variant] ?? palette.neutral;
    return (
        <Box
            component="span"
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                px: 1,
                py: 0.25,
                borderRadius: `${t.radius.sm}px`,
                backgroundColor: bg,
                color: fg,
                fontSize: `${t.type.caption.size}px`,
                fontWeight: 500,
                lineHeight: 1.4,
                whiteSpace: 'nowrap',
                ...sx,
            }}
        >
            {children}
        </Box>
    );
};

export default StatusPill;
